module.exports = new __parcel__URL__("temple_thumb.453867a6.jpg").toString();